module.exports = __webpack_public_path__ + "img/logo.f5eb00b0.png";